import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=52bde2a4&scoped=true"
import script from "./EditUser.vue?vue&type=script&lang=js"
export * from "./EditUser.vue?vue&type=script&lang=js"
import style0 from "./EditUser.vue?vue&type=style&index=0&id=52bde2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bde2a4",
  null
  
)

export default component.exports